import walidacjaMarki from '@components/form/validation/field/marka'
import validated from '@components/form/validation/validated'

const marka = { t: 'Marka', name: 'marka', hint: { url: '/make_all/truck', cache: 'truck-make-all', exact: true }}

export default validated(marka, walidacjaMarki)